import Row from 'react-bootstrap/Row';
import './Home.scss'
import { useState, useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../hooks/useIsMobile";
import useGroupMembership from "../../hooks/useGroupMembership";
import { accessGroups } from "../../config/authConfig";
import ChunkIndicesHealth from "./ChunkIndicesHealth";

function Home() {

    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const userGroups = useGroupMembership();

    const [accessLegal, setAccessLegal] = useState(false);
    const [accessOREIMA, setAccessOREIMA] = useState(false);
    const [accessInfra, setAccessInfra] = useState(false);
    const [accessFMC, setAccessFMC] = useState(false);
    const [accessGrowth, setAccessGrowth] = useState(false);
    const [accessLegalOreima, setAccessLegalOreima] = useState(false);
    const [accessAdmin, setAccessAdmin] = useState(false);
    const [accessCompliance, setAccessCompliance] = useState(false);
    const [accessMiddleOffice, setAccessMiddleOffice] = useState(false);
    const [accessAssistantes, setAccessAssistantes] = useState(false);
    const [accessHelpDesk, setAccessHelpDesk] = useState(false);
    const [accessDirectionSI, setAccessDirectionSI] = useState(false);
    const [accessFinance, setAccessFinance] = useState(false);
    const [accessLegalSPO, setAccessLegalSPO] = useState(false);
    const [accessAssetManagement, setAccessAssetManagement] = useState(false);
    const [accessInvestorRelations, setAccessInvestorRelations] = useState(false);
    //const [accessManagement, setAccessManagement] = useState(false);

    useEffect(() => {
        if (isAuthenticated && userGroups) {
            setAccessLegal(userGroups.some(group => accessGroups.legal.groupIds.includes(group)));
            setAccessOREIMA(userGroups.some(group => accessGroups.oreima.groupIds.includes(group)));
            setAccessInfra(userGroups.some(group => accessGroups.infra.groupIds.includes(group)));
            setAccessFMC(userGroups.some(group => accessGroups.fmc.groupIds.includes(group)));
            setAccessGrowth(userGroups.some(group => accessGroups.growth.groupIds.includes(group)));
            setAccessLegalOreima(userGroups.some(group => accessGroups.legalOreima.groupIds.includes(group)));
            setAccessAdmin(userGroups.some(group => accessGroups.admin.groupIds.includes(group)));
            setAccessCompliance(userGroups.some(group => accessGroups.compliance.groupIds.includes(group)));
            setAccessMiddleOffice(userGroups.some(group => accessGroups.middleOffice.groupIds.includes(group)));
            setAccessAssistantes(userGroups.some(group => accessGroups.assistantes.groupIds.includes(group)));
            setAccessHelpDesk(userGroups.some(group => accessGroups.helpDesk.groupIds.includes(group)));
            setAccessDirectionSI(userGroups.some(group => accessGroups.directionSI.groupIds.includes(group)));
            setAccessFinance(userGroups.some(group => accessGroups.finance.groupIds.includes(group)));
            setAccessLegalSPO(userGroups.some(group => accessGroups.legalSPO.groupIds.includes(group)));
            setAccessAssetManagement(userGroups.some(group => accessGroups.assetManagement.groupIds.includes(group)));
            setAccessInvestorRelations(userGroups.some(group => accessGroups.investorRelations.groupIds.includes(group)));
            //setAccessManagement(userGroups.some(group => accessGroups.management.groupIds.includes(group)));
        } else {
            setAccessLegal(false);
            setAccessOREIMA(false);
            setAccessInfra(false);
            setAccessFMC(false);
            setAccessGrowth(false);
            setAccessLegalOreima(false);
            setAccessAdmin(false);
            setAccessCompliance(false);
            setAccessMiddleOffice(false);
            setAccessAssistantes(false);
            setAccessHelpDesk(false);
            setAccessDirectionSI(false);
            setAccessFinance(false);
            setAccessLegalSPO(false);
            setAccessAssetManagement(false);
            setAccessInvestorRelations(false);
            //setAccessManagement(false);
        }
    }, [isAuthenticated, userGroups]);

    const tools = [
        {
            name: "Everyday chat, including professional data",
            icon: "bi bi-chat",
            description: "Open Copilot (SSO)",
            url: "https://m365.cloud.microsoft/chat/?auth=2&home=1&fromcode=cmm6e0ny53n",
            auth: true
        },
        {
            name: "Advanced search on the web, no professional data",
            icon: "bi bi-globe",
            description: "Open Perplexity (SSO)",
            url: "https://launcher.myapps.microsoft.com/api/signin/52a3b076-ec4b-40ce-92d7-018449b768d3?tenantId=7fc6be4a-81b6-457d-9ad7-c8d5c64d052c",
            auth: true
        },
        {
            name: "Search Infravia database",
            icon: "bi bi-database",
            description: "Search Infravia market data",
            url: "market?mode=SEARCH",
            auth:
                accessInfra ||
                accessFMC ||
                accessGrowth ||
                accessOREIMA ||
                accessAdmin ||
                accessCompliance ||
                accessMiddleOffice ||
                accessAssistantes ||
                accessHelpDesk ||
                accessDirectionSI ||
                accessFinance ||
                accessLegalSPO ||
                accessAssetManagement ||
                accessInvestorRelations //|| accessManagement
        },
        {
            name: "Search Live Deals database",
            icon: "bi bi-database",
            description: "Search your deals",
            url: "mydeal?mode=SEARCH",
            auth: accessInfra || accessFMC || accessGrowth || accessOREIMA || accessAdmin //|| accessManagement
        },
        {
            name: "Legal Contracts",
            icon: "bi bi-file-earmark-text",
            description: "Analyse legal contracts",
            url: "legal?mode=SEARCH",
            auth: accessLegal || accessAdmin //|| accessManagement
        },
        {
            name: "Chat with my documents",
            icon: "bi bi-folder",
            description: "Upload & chat with your documents",
            url: "market?mode=MYGEORGES",
            auth: true
        },
        {
            name: "Real-Estate contracts",
            icon: "bi bi-building",
            description: "Compare clauses between contracts",
            url: "oreima?mode=SEARCH",
            auth: accessLegalOreima || accessAdmin //|| accessManagement
        },
        {
            name: "Companies information",
            icon: "bi bi-search",
            description: "Use inven.ai for fast search of companies informations",
            url: "https://app.inven.ai/auth",
            auth: true
        }
    ]

    const handleEmailClick = () => {
        window.location.href = "mailto:georges@infraviacapital.com";
    };

    const handleUserGuideClick = () => {
        window.open(
            "https://infraviacapital.sharepoint.com/:f:/r/sites/prd-team-Infravia-Toolbox-And-Procedures/IT/Georges%20AI?csf=1&web=1&e=0d68A2",
            "_blank"
        );
    };

    const Tool = ({ tool }) => {
        const [hover, setHover] = useState(false);
        return (
            <div
                className="tool"
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => handleToolClick(tool)}
            >
                <i className={tool.icon} style={{ fontSize: "2em", fontWeight: "normal" }}></i>
                <div className="tool-name">{tool.name}</div>
                {hover && <div className="tool-description">{tool.description}</div>}
            </div>
        )
    }

    const handleToolClick = (tool) => {
        if (tool.url) {
            if (tool.url.startsWith('http')) {
                window.open(tool.url, '_blank');
            } else {
                navigate(tool.url);
            }
        }
    }

    return (
        <Row className="landing-page" style={{ overflowY: isMobile ? "scroll" : "hidden" }}>
            <div className="overlay">
                {isAuthenticated && <ChunkIndicesHealth />}
                {!isMobile && <div className="content">
                    <h1>Georges, your AI agent</h1>
                    {isAuthenticated && <p onClick={handleEmailClick} style={{ cursor: "pointer" }}>Ideas, questions, issues: write to Georges</p>}
                </div>}
                {isAuthenticated && <div className="tools">
                    <div style={{ width: "100%", textAlign: "center", fontSize: "1em", fontWeight: "bold", marginBottom: 10 }}>Where do you want to start ?</div>
                    {tools.filter(tool => tool.auth).map((tool) => (
                        <Tool key={tool.name} tool={tool} />
                    ))}
                </div>}
            </div>
        </Row>
    )
}

export default Home;